import { requestRegisterSpaceAdminReservation } from "services/resources/universitySpaces/aboutUniversitySpaceResources";
import useResourcesUniversitySpacesContext from "views/Recursos/ResourcesUniversitySpaces/utils/context/useResourcesUniversitySpacesContext";
import { ERROR_TEXTS } from "../constants";
import { wait } from "utils/others";

const useSpaceRegisterAdminReservation = ({
	formHandler: {
		form, errors
	}, spaceId, updateActivityPopup
}) => {
	const { loadingRequestOfReservationAction, spaceList } = useResourcesUniversitySpacesContext();
    async function registerAdminReservation() {
        if (!form.validate()) return;
        loadingRequestOfReservationAction.show("Registrando reserva...");
        const success = await requestRegisterSpaceAdminReservation({
            ...form.value, spaceId
        });
        loadingRequestOfReservationAction.hide();
        if (!success) {
            errors.setSchedule(ERROR_TEXTS.CROSS_SCHEDULES);
            return;
        }
        updateActivityPopup.popup.hide();
        await wait(220);
        spaceList.fill();
    }
	return registerAdminReservation;
}	
	
export default useSpaceRegisterAdminReservation;